import { render } from "./LoginAdmin.vue?vue&type=template&id=a3a4ff18"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Tsubakimoto\\Tsubakimoto_mvc\\Tsubakimoto\\tsubakimoto_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__